import {useTranslations} from "next-intl";
import React from 'react';

import ResourceMarkdown from '@/app-components/resouces/ResourceMarkdown';
import {BgDpcReviewerType} from "@/data/dtos/Resouces/BgDentalProcedureCodes/BgDpcReviewerType";
import {Link} from "@/i18n/routing";
import StringUtils from "@/utils/StringUtils";

export type ReviewerAvatarProps = {
	role:  'write' | 'review'
	author: BgDpcReviewerType;
};


function Avatar({ image, name }: { image: string|null, name:string }) {
	if (image) {
		return (

			<div className="avatar flex-shrink-0">
				<picture>
					<img className="avatar-img rounded-circle" src={image} alt={name}/>
				</picture>
			</div>

		);
	}
	return (
		<div className="avatar flex-shrink-0">
			<div className="avatar-img rounded-circle bg-dark bg-opacity-10">
					<span className="position-absolute top-50 start-50 translate-middle fw-bold">
						{StringUtils.getInitials(name)}
					</span>
			</div>
		</div>
	);
}


export default function ReviewerAvatarClient({ author, role }: ReviewerAvatarProps) {
	const t = useTranslations('page.r-bg-dental-procedure-codes.common_used');

	const roleLabel = (role =='review' ? t('fact_checked_by') : t('written_by')) + " ";

	return (
		<div className="d-flex justify-content-start align-items-center mb-5 mb-sm-0">
			<div className="avatar flex-shrink-0">
				{
				author.link
					?
					<Link className="heading-color" href={author.link}>
						<Avatar image={author.avatar} name={author.name} />
					</Link>
					:
					<Avatar image={author.avatar} name={author.name} />

				}
			</div>
			<div className="ms-2">
				<div className="mb-0 heading-color">
					{ roleLabel }

					{
					author.link
						?
						<Link className="fw-medium heading-color" href={author.link}>
							{ author.nameWithPrefix }
						</Link>
						:
						author.nameWithPrefix

					}
				</div>
				<ResourceMarkdown pClassName='mb-0 small'>
					{ author.headline}
				</ResourceMarkdown>
			</div>
		</div>
	);
}